export enum ProductDetailsSection {
  description = 'Description',
  installationDetails = 'Installation details',
  calculationResult = 'Calculation result',
  inputDetails = 'Input details',
}
